import React, {VoidFunctionComponent} from "react";

export const ContactICon: VoidFunctionComponent = () => (
    <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M20.5038 11.8404C20.8254 11.3104 21 10.7411 21 10.1485C21 7.30667 16.9871 5 12.0117 5C7.03626 5 3 7.30329 3 10.1485C3 11.8116 4.38538 13.2918 6.53006 14.2335C5.97315 15.6167 5.18438 16.8911 4.19888 18C6.1071 17.2439 7.92755 16.2761 9.62721 15.1141C10.4152 15.2365 11.2112 15.2977 12.0083 15.297C12.6374 15.297 13.2511 15.2602 13.8433 15.19M16.281 13.7999L17.2735 14.8364L18.8487 13.0446M20.9034 13.7525C20.9034 14.4827 20.6905 15.1965 20.2917 15.8036C19.8928 16.4108 19.3259 16.884 18.6626 17.1635C17.9993 17.4429 17.2694 17.516 16.5653 17.3736C15.8611 17.2311 15.2143 16.8795 14.7067 16.3631C14.199 15.8468 13.8533 15.1889 13.7132 14.4728C13.5732 13.7566 13.6451 13.0142 13.9198 12.3396C14.1946 11.665 14.6598 11.0883 15.2567 10.6827C15.8537 10.277 16.5555 10.0604 17.2735 10.0604C18.2362 10.0604 19.1595 10.4494 19.8402 11.1418C20.521 11.8342 20.9034 12.7733 20.9034 13.7525Z"
            stroke="#171A1C"
            strokeWidth="1.2"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
);